export class RespuestaModel {
    constructor() { }

    public get CantidadDeErrores(): number { return this.Error.length; };
    public Error: string[] = [];
    public Resultado: any = null;
    public Token = '';
    public TiempoDeEjecucion = '';
    public EntityFrameworkLog: string[] = [];
    public Log: string[] = []
}